import { API_URL, headers } from '../config';
import { fetchHandler, fetchErrorHandler } from '../middleware';

export function addOrgToGroup(groupId, orgId) {
  return getGroupToken(groupId, orgId)
    .then((data) => addOrgToGroupWithToken(data[0].token, groupId, orgId))
    .catch((error) => Promise.reject(error));
}

function addOrgToGroupWithToken(token, groupId, orgId) {
  return fetch(`${API_URL}/groups/${groupId}/addtogroup/${orgId}`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ token }),
  });
}

function getGroupToken(groupId, orgId) {
  // TODO: this endpoint only takes an array of org ids.
  const orgids = new Array(1);
  orgids[0] = orgId;

  return fetch(`${API_URL}/groups/${groupId}/token`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ orgids }),
  })
    .then(fetchHandler((body) => Promise.resolve(body.data)))
    .catch(fetchErrorHandler);
}
